<template>
  <b-card class="rounded-0 h-100 m-0">
    <b-row>
      <b-form class="p-2">
        <b-form-group label="Movie :- ">
          <p class="value-text">{{ data.titles }}</p>
        </b-form-group>
        <b-form-group label="Licensor/Licensee :- ">
          <p class="value-text">{{ data.company }}</p>
        </b-form-group>
        <b-form-group label="Title :- ">
          <p class="value-text">{{ data.bumper_name }}</p>
        </b-form-group>
        <b-form-group label="Amount :- ">
          <p class="value-text">
            {{ formatCurrency(data.amount) }}
          </p>
        </b-form-group>
        <b-form-group label="Date :- ">
          <flat-pickr
            placeholder="Date"
            class="form-control"
            v-model="form.date"
            :disabled="true"
            :config="{
              ...$flatPickrConfig,
            }"
          />
        </b-form-group>
        <b-form-group label="Comment">
          <b-form-input v-model="form.comment" />
        </b-form-group>
        <b-form-group label="Amount Paid">
          <b-form-input v-model="form.amount_paid" />
        </b-form-group>
        <b-form-group label="Payment Date :- ">
          <flat-pickr
            placeholder="Payment Date"
            class="form-control"
            v-model="form.payment_date"
            :config="{
              ...$flatPickrConfig,
            }"
          />
        </b-form-group>
          <b-button
            style="width: 100%;"
            variant="primary"
            @click="
              () => {
                showModal('Are you sure want to submit?', 'save').then(
                  (value) => {
                    if (value) saveBumper();
                  }
                );
              }
            "
            >Save</b-button
          >
      </b-form>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import * as ContractServices from "@/apiServices/ContractServices";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import { formatCurrency } from "@/utils/helpers";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import showModal from "../../../components/ModalConfirmation";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    vSelect,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
        date: "",
        comment: "",
        amount_paid: "",
        payment_date: "",
      },
    };
  },
  watch: {
    data(newVal, oldVal) {
      this.form = {
        ...this.form,
        ...newVal,
      };
    },
  },
  methods: {
    showModal,
    formatCurrency,
    moment,
    async saveBumper() {
      try {
        const response = await ContractServices.SaveContractBumper({
          id: this.data.id,
          ...this.form,
        });

        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "success",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$emit("saved");
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Failed to save",
              icon: "EditIcon",
              variant: "failure",
            },
          });
        }
      } catch (error) {
        console.error("Error in save bumper");
      }
    },
  },
};
</script>

<style>
hr.dotted {
  border-top: 2px dotted #999;
  width: 96%;
}
.value-text {
  color: black;
  font-weight: bold;
}
</style>
